import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from '../assets/icons';
import Alerta from '../components/Alerta';
import { ATag } from '../components/ATag';
import { useRegistro } from '../hooks/useRegistro';

const ActualizarCv = () => {

    const {
        procesarArchivos,
        mostrarAlertaSize,
        mostrarAlertaSizeTexto,
        mostrarAlertaSizeColor,
        actualizarArchivoCv,
        btn
      } = useRegistro();

  return (
    <div className="row">
      <div className="d-flex justify-content-center mt-4 mb-5">
        <div className="col-8">
            <div className="card card-body">

                <div>
                    <Link to="/registro">
                        <ArrowLeft/> Volver
                    </Link>
                </div>

                <form autoComplete="off" onSubmit={ (e) => actualizarArchivoCv(e) }>
                
                    <div className='my-3'>

                        <p className="lead">
                            Subir los siguientes documentos en un sólo archivo
                            en formato PDF.
                        </p>

                        <ol>
                            <li>CV</li>
                            <li>Título (Copia ambos lados)</li>
                            <li>Cédula profesional o técnica</li>
                            <li>RFC Constancia del SAT</li>
                            <li>
                            <ATag
                                link="https://serviciosdigitales.imss.gob.mx/gestionAsegurados-web-externo/asignacionNSS"
                                texto="NSS Numero de Seguridad social (hoja del IMSS)"
                                clases=''/>
                            </li>
                            <li>INE</li>
                            <li>
                            <ATag
                                link="https://www.gob.mx/curp/"
                                texto="CURP"
                                clases=''/>
                            </li>
                            <li>Acta de nacimiento</li>
                            <li>Comprobante de domicilio</li>
                            <li>Constancia de no habilitación</li>
                            <li>Anexos (Constancias laborales y diplomas)</li>
                        </ol>

                        <div className='alert alert-info'>
                            La constancia de habilitación o no inhabilitación como Servidores Públicos, la expide la Secretaría de Transparencia y Rendición de Cuentas, a través de la Dirección de Asuntos Jurídicos, el trámite ES GRATUITO y se puede realizar de manera remota, enviando un correo electrónico a la siguiente cuenta:
                            <br/>
                            <b>
                            <a href='mailto:constancias.inhabilitacion@sinaloa.gob.mx'>
                                constancias.inhabilitacion@sinaloa.gob.mx
                            </a>
                            </b>
                            <br/>
                            <br/>
                            Los requisitos son los siguientes:
                            <br/>
                            <br/>
                            Escanear originales de:
                            <ul>
                            <li>Identificación oficial vigente (credencial de elector, pasaporte o cédula profesional).</li>
                            <li>Comprobante de domicilio no mayor a tres meses (de agua o de luz).</li>
                            <li>Constancia de Situación Fiscal, expedida por el SAT, esta se puede obtener desde la página del SAT.</li>
                            </ul>
                            
                            
                            Recibirán un formato, el cual se debe llenar, imprimir y firmar, y escanear de nuevo.

                            

                            Todas las constancias se envían a la 1 de la tarde, en caso de enviarlo a primera hora de ese mismo día, de lo contrario lo recibirán al siguiente día a la 1 pm.
                        </div>

                        <div className='alert alert-info'>
                            <small>
                            Tamaño máximo del archivo: <b>30 MB</b>
                            </small>
                        </div>
                        {
                            mostrarAlertaSize && (
                            <Alerta texto={ mostrarAlertaSizeTexto } tipo={ mostrarAlertaSizeColor }/>
                            )
                        }
                        
                        <input
                            className="form-control form-control-lg mb-5"
                            id="formFileLg"
                            type="file"
                            accept=".pdf"
                            required
                            onChange={(e) => procesarArchivos(e)}
                        />
                        { btn }
                    </div>
                </form>
            </div>
        </div>
      </div>
    </div>
  );
};

export default ActualizarCv;
